var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.onClickOutside),expression:"onClickOutside"}],staticClass:"eye-dropper-container",style:({
    top: ((_vm.canvasRect.top) + "px"),
    left: ((_vm.canvasRect.left) + "px"),
    width: ((_vm.canvasRect.width) + "px"),
    height: ((_vm.canvasRect.height) + "px"),
    cursor: ("url(" + _vm.eyeDropperIcon + ") 12 12, auto")
  }),on:{"click":_vm.onClick}},[_c('PpEyeDropper',{attrs:{"color":_vm.color},on:{"colorChange":_vm.onChangeColor,"keyPress":_vm.onKeyPress}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }